import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class ResultsTeamsController extends Controller
{
	@tracked selectedClassGroup = null;

	@action
	refresh()
	{
		this.send('refreshModel');
	}

	@action
	onClassGroupChange(classGroup)
	{
		this.selectedClassGroup = classGroup;
	}
}